import axios from "axios";

const endpoint_url = "/campaign/api/admin/lucky-draws";

const get = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, {
        params: {
          draw: parameters.draw,
          limit: parameters.length,
          skip: parameters.start,
          sortBy: parameters.column,
          order: parameters.order,
          search: parameters.search,
          product: parameters.product
        },
      })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const getAllLuckyDraw = {
  get
};

export default getAllLuckyDraw;
